import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]

import {computed} from "vue";

interface Props {
  nested?: boolean;
  space?: boolean;
  round?: MaterialRound;
  href?: string;
  disabled?: boolean;
}

export type MaterialRound = 'regular'|'large'|'full';


export default /*@__PURE__*/_defineComponent({
  __name: 'Material',
  props: {
    nested: { type: Boolean },
    space: { type: Boolean },
    round: {},
    href: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const tileClass = computed(() => [background(), rounded(), padding()]);

function background(): string {
  if (props.disabled) {
    return 'bg-neutral2-025';
  }
  return props.nested ? 'bg-tile-nested' : 'bg-tile';
}

function rounded(): string {
  if (props.round === 'full') {
    return 'rounded-3xl';
  }
  if (props.round === 'large') {
    return 'rounded-2xl';
  }
  return 'rounded-lg';
}

function padding(): string {
  return props.space ? 'p-4' : 'p-2';
}

return (_ctx: any,_cache: any) => {
  return (props.href)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: props.href,
        class: _normalizeClass(["block", tileClass.value])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(tileClass.value)
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2 /* CLASS */))
}
}

})